/**
 * Extracts user-friendly error messages from HTTP error responses
 */
export const extractErrorMessage = (error: unknown): string => {
  // Check if error has the standard structure: { error: { field: ["message"] } }
  if (
    error &&
    typeof error === 'object' &&
    'error' in error &&
    error.error &&
    typeof error.error === 'object'
  ) {
    const errorObj = error.error as Record<string, unknown>;
    const entries = Object.entries(errorObj);

    if (entries.length > 0) {
      const [, value] = entries[0];

      // Handle array format: ["Error message 1", "Error message 2"]
      if (Array.isArray(value) && value.length > 0) {
        return value.join(', ');
      }

      // Handle string format: "Error message"
      if (typeof value === 'string') {
        return value;
      }
    }
  }

  // Fallback to error.message if available
  if (
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    return error.message;
  }

  return 'An unexpected error occurred';
};
